import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  CloseButtonContainer,
  ModalCloseButton,
} from '../../common/components/ModalCloseButton';
import {
  Container,
  ModalText,
  StyledDialog,
} from '../Notifications/styledComponent';

const ButtonContainer = styled.div`
  margin: 40px -50px -35px -50px;
`;

const ModalButton = styled.button`
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  width: 50%;
  height: ${p => (p.theme.isMobile ? '70px' : '85px')};
  cursor: pointer;
`;

export interface DeleteConfirmModalProps {
  onClickDeleteButton: () => void;
  open: boolean;
  onClose: () => void;
}
export const DeleteConfirmModal = (props: DeleteConfirmModalProps) => {
  const { onClickDeleteButton, open, onClose } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.myImageList.deleteConfirmModal',
  });

  return (
    <StyledDialog open={open} onClose={onClose}>
      <Container>
        <CloseButtonContainer>
          <ModalCloseButton onClick={onClose} />
        </CloseButtonContainer>
        <ModalText>{t('content')}</ModalText>
        <ButtonContainer>
          <ModalButton onClick={onClose}>{t('cancelBtn')}</ModalButton>
          <ModalButton
            style={{ borderLeft: 'none' }}
            onClick={onClickDeleteButton}>
            <strong>{t('submitBtn')}</strong>
          </ModalButton>
        </ButtonContainer>
      </Container>
    </StyledDialog>
  );
};
